import ModalSectionView from "../../modal/view/section.js";

import {
  CLOSE_BUTTON_TEXT,
  MODAL_HEADING,
  MODAL_INPUT_PLACEHOLDER,
  SEARCH_TEXT
} from "../lexicon.js";

const createCitySelectModalSectionTemplate = () => {
  return (
    `<section class="city-select-modal-section">
      <button class="city-select-modal-close-button">
        <span class="visually-hidden">${CLOSE_BUTTON_TEXT}</span>
      </button>
      <div class="city-select-modal">
        <h2 class="heading heading_h3 city-select-modal-heading">${MODAL_HEADING}</h2>
        <form class="city-select-modal-form">
          <input class="form-input form-input_search" type="search" autocomplete="off" name="city-search" placeholder="${MODAL_INPUT_PLACEHOLDER}">
          <button class="search-form__button" type="submit" tabindex="-1">
            <span class="visually-hidden">${SEARCH_TEXT}</span>
          </button>
        </form>
        <ul class="city-select-modal__cities-list">
        </ul>
      </div>
    </section>`
  );
};

export default class CitySelectModalSection extends ModalSectionView {
  constructor() {
    super();

    this._closeButtonClass = `city-select-modal-close-button`;
    this._createModalSectionTemplate = createCitySelectModalSectionTemplate;
    this._citiesListElement = null;
    this._inputElement = null;
    this._formElement = null;

    this._closeButtonFocusHandler = this._closeButtonFocusHandler.bind(this);
    this._inputInputHandler = this._inputInputHandler.bind(this);
    this._formSubmitHandler = this._formSubmitHandler.bind(this);
  }

  getCitiesListElement() {
    if (!this._citiesListElement) {
      this._citiesListElement = this.getElement().querySelector(`.city-select-modal__cities-list`);
    }

    return this._citiesListElement;
  }

  getFormElement() {
    if (!this._formElement) {
      this._formElement = this._element.querySelector(`form`);
    }

    return this._formElement;
  }

  getInputElement() {
    if (!this._inputElement) {
      this._inputElement = this._element.querySelector(`input`);
    }

    return this._inputElement;
  }

  getInputValue() {
    return this.getInputElement().value;
  }

  focusInputElement() {
    this.getInputElement().focus();
  }

  reset() {
    super.reset();

    this._citiesListElement = null;
  }

  setCloseButtonFocusHandler(callback) {
    this._callback.closeButtonFocus = callback;
    this.getCloseButton().addEventListener(`focus`, this._closeButtonFocusHandler);
  }

  setInputInputHandler(callback) {
    this._callback.inputInput = callback;
    this.getInputElement().addEventListener(`input`, this._inputInputHandler);
  }

  setFormSubmitHandler(callback) {
    this._callback.formSubmit = callback;
    this.getFormElement().addEventListener(`submit`, this._formSubmitHandler);
  }

  _closeButtonFocusHandler() {
    this._callback.closeButtonFocus();
  }

  _inputInputHandler() {
    this._callback.inputInput(this.getInputValue());
  }

  _formSubmitHandler(evt) {
    this._callback.formSubmit(evt, this.getInputValue());
  }
}
